import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import Button from '../../../../components/Button';
import { ModalProps } from '../../../../components/Modal';
import ContainerModal from '../../../../components/ContainerModal';

const warningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';
const successIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/conclusion.svg';
import { useContextSelector } from 'use-context-selector';
import { removeAppointment, removeAppointmentSpecialist } from '../../../../modules/slots';
import { toast } from 'react-toastify';
import { PlatformContext } from '../../../../contexts/PlatformContext';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { specialistAppointment } from '../../../../models/specialistAppointment';
import { FirebaseEvents } from '../../../../utils/enums/firebase-events';

type ContainerProps = {
  scheduleRemoved: boolean;
};

const Container = styled.div<ContainerProps>`
  padding-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (min-width: 900px) {
    padding-bottom: 56px;
    padding-top: ${({ scheduleRemoved }) => (scheduleRemoved ? '0' : '64px')};
  }

  .conclusion-icon {
    margin-bottom: 24px;
  }

  .icon {
    width: 120px;
    margin-bottom: 24px;
  }
`;
const H3 = styled.h3`
  ${({ theme }) => css`
    color: ${theme.colors.colorGray500};
    font-weight: 500;
    font-size: 24px;
    text-align: center;
  `}
`;

type CancelModalProps = {
  scheduleId: string | number;
  verificationCode: string;
  setLoading: (loading: boolean) => void;
  specialist: boolean;
  specialistAppointment?: specialistAppointment;
} & Pick<ModalProps, 'visible' | 'onClose'>;

const CancelModal: React.FC<CancelModalProps> = ({
  visible,
  onClose,
  scheduleId,
  setLoading,
  verificationCode,
  specialist,
  specialistAppointment
}) => {
  const [scheduleRemoved, setScheduleRemoved] = React.useState(false);
  const { setIsSchedulerOpen } = useContextSelector(PlatformContext, state => state);

  const { logEvent } = useAnalytics();

  useEffect(() => {
    setScheduleRemoved(false);
  }, []);

  const handleRemove = async (id: string | number, verificationCode: string) => {
    try {
      setLoading(true);
      if (specialist) await removeAppointmentSpecialist(id, verificationCode);
      else await removeAppointment(id, verificationCode);

      logEvent({
        eventName: FirebaseEvents.schedule_cancelled,
        eventParams: {
          product_id: specialistAppointment?.id,
          product_name: specialistAppointment?.resourceName,
          date: `${specialistAppointment?.scheduleDate}T${specialistAppointment?.scheduleTime}`,
          // service: {
          //   id: schedule.catalog.serviceId,
          //   name: schedule.catalog.name
          // },
          attendanceType: specialistAppointment?.attendance_type,
          unit_id: '',
          unit_name: specialistAppointment?.unit_name,
          payment_type: specialistAppointment?.payment_type ?? ''
          // type: specialistAppointment.
        }
      });

      setScheduleRemoved(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Não foi possível cancelar o agendamento');
      console.error(error);
    }
  };

  return (
    <ContainerModal
      visible={visible}
      onClose={onClose}
      withoutCloseButton
      childrenFooter={
        <>
          {!scheduleRemoved && (
            <Button
              title="Sim"
              onClick={() => {
                handleRemove(scheduleId, verificationCode);
              }}
            />
          )}
          <Button
            title={!scheduleRemoved ? 'Não' : 'Fechar'}
            tertiary={!scheduleRemoved}
            onClick={() => {
              if (!scheduleRemoved) {
                onClose();
              } else {
                onClose();
                setIsSchedulerOpen(false);
              }
            }}
          />
        </>
      }
    >
      <Container scheduleRemoved={!scheduleRemoved}>
        {!scheduleRemoved ? (
          <>
            <img src={warningIcon} alt="" className="icon" />
            <H3>Tem certeza que deseja cancelar o agendamento?</H3>
          </>
        ) : (
          <>
            <img src={successIcon} alt="" className="icon" />
            <H3>Seu agendamento foi cancelado!</H3>
          </>
        )}
      </Container>
    </ContainerModal>
  );
};

export default CancelModal;
